import React from "react"
import { useTranslation } from "react-i18next"
import Misconceptions from "../component/sections/Misconceptions"
import ScienceBehindIntroversion from "../component/sections/ScienceBehindIntroversion"
import StrengthsOfIntroverts from "../component/sections/StrengthsOfIntroverts"

const IntrovertInsights = () => {
  const { t } = useTranslation()

  return (
    <>
      <section className="mx-auto max-w-7xl p-8 bg-blue-100">
        <h1 className="text-2xl md:text-4xl font-semibold mb-4">
          {t("introvert-insights.title")}
        </h1>
        <p className="text-lg md:text-xl text-gray-600">
          {t("introvert-insights.subtitle")}
        </p>
      </section>
      <Misconceptions />
      <ScienceBehindIntroversion />
      <StrengthsOfIntroverts />
    </>
  )
}

export default IntrovertInsights
